import { Model } from '../general'

export interface Data {
  id: number
  company_id: number
  location_id?: number
  building_id?: number
  name?: string
  description?: string
  created_by?: number
  created_at?: string
  updated_by?: number
  updated_at?: string
  nr_of_workspaces?: number
}

class Zone extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }
  get locationId() {
    return this.data.location_id
  }
  get buildingId() {
    return this.data.building_id
  }
  get createdBy() {
    return this.data.created_by || NaN
  }
  get createdAt() {
    return this.data.created_at
  }
  get updatedBy() {
    return this.data.updated_by || NaN
  }
  get updatedAt() {
    return this.data.updated_at
  }
  get name() {
    return this.data.name
  }
  get description() {
    return this.data.description
  }
  get searchText(): string {
    return `${this.name}`
  }
  get numberOfWorkspaces() {
    return this.data.nr_of_workspaces || 0
  }
}

export default Zone
